var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/family/family-title.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<div class=\"o-row\">\n\n\t<div class=\"o-column o-extra-small--12\">\n\t\t   \n\t\t<h2 class=\"c-family-product__h2\">\n\n\t        ";
output += runtime.suppressValue((lineno = 8, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_shop-the-set-title",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n\n\t    </h2>\n\t\t\n\t</div>\n\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/family/family-title.j2"] , dependencies)